function openSidebar() {
    const page = document.getElementById("page");

    page.classList.remove("scouts_mobile-sidebar-hidden");
    page.classList.add("scouts_mobile-sidebar-visible");
}

function closeSidebar() {
    const page = document.getElementById("page");

    page.classList.remove("scouts_mobile-sidebar-visible");
    page.classList.add("scouts_mobile-sidebar-hidden");
}

const mql = window.matchMedia("(max-width: 1400px)");

mql.addEventListener("change", () => {
    if (!mql.matches) {
        const page = document.getElementById("page");
    
        page.classList.remove("scouts_mobile-sidebar-visible");
        page.classList.remove("scouts_mobile-sidebar-hidden");
    }
});

// add events for hamburger button and overlay
document.getElementById('scouts-sidebar-hamburger').addEventListener('click', openSidebar);
document.getElementById('overlay').addEventListener('click', closeSidebar);
